// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/wir-sind-gruendungsmitglied-im-unternehmensnetzwerk-klimaschutz/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const wirSindGruendungsmitgliedImUnternehmensnetzwerkKlimaschutzDE: PageEntry = {
  id: "post.wir-sind-gruendungsmitglied-im-unternehmensnetzwerk-klimaschutz",
  locale: "de",
  slug: "wir-sind-gruendungsmitglied-im-unternehmensnetzwerk-klimaschutz",
  seo: {
    title: "Wir sind Gründungsmitglied im Unternehmensnetzwerk Klimaschutz | Dietz GmbH",
    description: "Wir sind Gründungsmitglied im Unternehmensnetzwerk Klimaschutz",
  },
  type: "post",
  h1: "Wir sind Gründungsmitglied im Unternehmensnetzwerk Klimaschutz",
  blocks: [
    { kind: "heading", level: 2, text: "Wir sind Gründungsmitglied im Unternehmensnetzwerk Klimaschutz" },
    { kind: "paragraph", text: "Das Unternehmensnetzwerk Klimaschutz dient der Vernetzung und dem Erfahrungsaustausch der Mitgliedsunternehmen." },
    { kind: "paragraph", text: "Es bietet zahlreiche Angebote und praxisnahe Hilfestellungen. Gemeinsam gilt es einen aktiven Beitrag zum Klimaschutz zu leisten und das eigene Know-How kontinuierlich voranzubringen." },
    { kind: "paragraph", text: "Wir sind sehr stolz ein Gründungsmitglied in diesem Netzwerk zu sein und unsere Erfahrungen zu teilen und zu erweitern." },
    { kind: "paragraph", text: "Als Mitglied im UNK bestätigen wir, dass wir dem betrieblichen Klimaschutz eine wichtige Bedeutung im Unternehmen beimessen, uns ambitionierte Ziele setzen und an einer kontinuierlichen Verbesserung der Klimaleistung im Unternehmen arbeiten wollen." }
  ],
};
